import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'Loader',
  setup(__props) {

const loader = computed(() => store.getters.loader);
const theme = computed(() => store.getters.theme);

return { __sfc: true,loader, theme }
}

})